import React from 'react';
import Navigation from '../components/Navigation';
import Logo from '../components/Logo';


const About = () => {
   return (
      <div className="about">
         <Navigation />
         <Logo/>
         <h1>A propos</h1>
         <br />
         <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
            nulla laudantium aliquid minus delectus repellendus hic fugit
            dolorum, nisi amet modi illum. Nostrum reiciendis eos dicta. Totam
            dolor saepe placeat! Obcaecati quae sapiente, quisquam optio error
            debitis est ea vitae veniam nisi similique? Officia sequi veniam,
            doloremque ex hic ducimus expedita voluptas ullam ab ipsum,
            voluptates mollitia quo vero iure. Corporis esse sunt temporibus
            aliquam molestias quae quia quisquam et sed nesciunt laudantium
            voluptatum magni earum nulla ratione nam porro, quas, ex dolorem
            quibusdam necessitatibus dolorum! Aliquam animi voluptatibus
            inventore! Nam esse, soluta odio nesciunt voluptatem at culpa
            facilis sequi repellendus assumenda earum molestias necessitatibus
            tenetur magni saepe illum adipisci harum natus cum! Explicabo fugiat
            accusantium ex asperiores cum porro?
         </p>
         <br />
         <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Error
            assumenda repellat illum earum nam, ipsam dolore quibusdam molestias
            dolores quia officiis officia et inventore quidem ratione omnis
            mollitia veritatis similique. Laudantium odit dolore eum aliquam
            sint, harum error repellat praesentium voluptate, est distinctio
            labore cumque quod deserunt qui debitis, delectus architecto optio
            veniam soluta ullam vero nulla et. Dolore, architecto! Nobis placeat
            magni voluptas amet omnis obcaecati ad aliquam pariatur maxime illum
            tempore corrupti illo dolorem repellat aspernatur necessitatibus
            sunt, perferendis totam accusantium saepe earum soluta eum velit
            aperiam. Eligendi? Ea molestiae dolores modi magnam aperiam vel.
            Ducimus quae asperiores, necessitatibus, cupiditate error
            accusantium laboriosam eligendi explicabo animi, porro ipsam ratione
            nulla. Minus numquam, quasi tempora rerum recusandae at dolores.
            Quibusdam laudantium omnis ipsa quod temporibus tenetur earum enim
            soluta quaerat adipisci debitis minima animi voluptatibus esse vel
            quam dolore, explicabo illo dolorum ducimus ut accusantium. A
            tenetur minima labore. Dolore at ducimus reiciendis! Accusamus
            aliquid reiciendis amet, placeat atque numquam blanditiis alias
            aspernatur quos est quod dolore explicabo quaerat voluptatem, quo
            eaque cupiditate, facere asperiores sequi doloremque praesentium
            sit.
         </p>
      </div>
   );
};

export default About;
